// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__zA3xZ","actions":"GroupTable_actions__2IUHJ","deleteModalFooter":"GroupTable_deleteModalFooter__2qDcm"};